import { useState } from 'react'
import { useApiClient, UseObservationLogsSearchParams } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export const useObservationLogsExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const doExport = async ({ ...params }: UseObservationLogsSearchParams) => {
    const queryParams = new URLSearchParams()

    if (params.id) queryParams.append('id', params.id)
    if (params.search) queryParams.append('search', params.search)
    if (params.createdBy) queryParams.append('createdBy', params.createdBy)
    if (params.isPlaceFound !== undefined)
      queryParams.append('is_place_found', params.isPlaceFound ? '1' : '0')
    if (params.behaviour) queryParams.append('behaviour', params.behaviour)
    if (params.specie) queryParams.append('specie', params.specie)
    if (params.observationType)
      queryParams.append(
        'research_observation_log_type',
        params.observationType
      )
    if (params.project_leader)
      queryParams.append('project_leader', params.project_leader)
    if (params.hasProcessingComment !== undefined)
      queryParams.append(
        'has_processing_comment',
        params.hasProcessingComment ? '1' : '0'
      )
    if (params.hasSoundRecordings !== undefined)
      queryParams.append(
        'has_sound_recordings',
        params.hasSoundRecordings ? '1' : '0'
      )
    if (params.isApproved !== undefined)
      queryParams.append('is_approved', params.isApproved ? '1' : '0')
    if (params.isSoundRecordingsAnalysed !== undefined)
      queryParams.append(
        'is_sound_recordings_analysed',
        params.isSoundRecordingsAnalysed ? '1' : '0'
      )

    if (params.startDate) queryParams.append('date_start', params.startDate)
    if (params.endDate) queryParams.append('date_end', params.endDate)
    if (params.task_status)
      queryParams.append('task_status', params.task_status)

    setLoading(true)
    try {
      const response = await client.get<Blob>(
        `/plannings/observation_logs/export/?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { doExport, loading }
}
